import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import IncomingInvoicesPage from "./pages/IncomingInvoicesPage";
import OutgoingInvoicesPage from "./pages/OutgoingInvoicesPage";
import ContactsPage from "./pages/ContactsPage";
import ExportPage from "./pages/ExportPage";
import SettingsPage from "./pages/SettingsPage";
import UStVAPage from "./pages/UStVAPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import TaxReturnPage from "./pages/TaxReturnPage";
import QuotesPage from "./pages/QuotesPage";
import { Toaster } from "./components/ui/sonner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  return user ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  return user ? <Navigate to="/dashboard" replace /> : children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
      <Route path="/e-mail-bestaetigen" element={<VerifyEmailPage />} />
      <Route path="/passwort-vergessen" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>} />
      <Route path="/passwort-neu" element={<ResetPasswordPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="eingangsrechnungen" element={<IncomingInvoicesPage />} />
        <Route path="ausgangsrechnungen" element={<OutgoingInvoicesPage />} />
        <Route path="angebote" element={<QuotesPage />} />
        <Route path="umsatzsteuer" element={<UStVAPage />} />
        <Route path="steuererklaerung" element={<TaxReturnPage />} />
        <Route path="kontakte" element={<ContactsPage />} />
        <Route path="export" element={<ExportPage />} />
        <Route path="einstellungen" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster richColors position="top-right" />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
